export default "__VITE_ASSET__BXKe8NVN__"